import { Component } from 'react';
import BookdocApi from '../../services/BookdocApi';

class SearchForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            awards: []
        }
    }

    componentDidMount() {
        this.listCategories();
        this.listAwards();
    }

    listCategories = () => {
        BookdocApi.getActivCategories().then((data) => {
            this.setState({
                categories: data.categories
            })
        });
    }

    listAwards = () => {
        BookdocApi.getAwards().then((data) => {
            this.setState({
                awards: data
            })
        });
    }

    render() {
        const categories = this.state.categories.map((category) => {
            return (
                <option key={category.id} value={category.id}>{category.name}</option>
            );
        });
        const awards = this.state.awards.map((award) => {
            return (
                <option key={award.id} value={award.id}>{award.name}</option>
            );
        });

        return (
            <form className="form-inline justify-content-end" onSubmit={this.props.handleSearch}>
                <div className="form-group">
                    <select className="form-control" id="category_id" name="category_id">
                        <option value="">Select Category</option>
                        {categories}
                    </select>
                    <select className="form-control" id="award_id" name="award_id">
                        <option value="">Select Tier</option>
                        {awards}
                    </select>
                    <div className="input-group">
                        <input type="text" className="form-control" id="search" name="search" placeholder="Search" />
                        <button type="submit" className="btn btn-danger"><i className="fa fa-search"></i></button>
                    </div>
                </div>
            </form>
        )
    }
}

export default SearchForm;
